/**
 * Exam API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'

const examApi = {
    // 시험 인트로(get exam intro information)
    //https://clpapi.tinkeredu.co.kr/static/docs/exam.html#resources-exam-examinee-intro
    examIntro(params) {
        return httpService.get(`/exam/examinee/${params.examineeId}/intro`)
    },

    // 시험 시작(set exam start)
    //https://clpapi.tinkeredu.co.kr/static/docs/exam.html#resources-exam-examinee-start
    start(params) {
        return httpService.post(`/exam/examinee/${params.examineeId}/start`)
    },

    // 시험지 정보(get exam information)
    //https://clpapi.tinkeredu.co.kr/static/docs/exam.html#resources-exam-examinee-window
    window(params) {
        return httpService.get(`/exam/examinee/${params.examineeId}/window`)
    },
    
    // 시험 문항정보(get exam question groups information)
    //https://clpapi.tinkeredu.co.kr/static/docs/exam.html#resources-exam-examinee-group-list
    groups(params) {
        return httpService.get(`/exam/examinee/${params.examineeId}/groups`)
    },

    // 시험지 제출(submit exam)
    //https://clpapi.tinkeredu.co.kr/static/docs/exam.html#resources-exam-examinee-paper-submit
    submit(params) {
        return httpService.put(`/exam/examinee/${params.examineeId}/submit`, params.answers)
    },

    // 제출된 시험지 목록(get submited exam list)
    //https://clpapi.tinkeredu.co.kr/static/docs/exam.html#resources-exam-examinee-submitted-paper-list
    submitedList(params) {
        return httpService.get(`/exam/examinee/${params.examineeId}/result`)
    },

    // 시험 결과(get exam result)
    //https://clpapi.tinkeredu.co.kr/static/docs/exam.html#resources-exam-examinee-submitted-paper-detail
    result(params) {
        return httpService.get(`/exam/examinee/${params.examineeId}/result/${params.paperId}`)
    },

    // 시험 점수 정보(get exam score information)
    //https://clpapi.tinkeredu.co.kr/static/docs/exam.html#resources-exam-examinee-result-score
    score(params) {
        return httpService.get(`/exam/examinee/${params.examineeId}/result/score`)
    },

    // 시험 뱃지(get exam badges list)
    // https://clpapi.tinkeredu.co.kr/static/docs/exam.html#resources-exam-examinee-badges
    badges(params) {
        return httpService.get(`/exam/examinee/${params.examineeId}/badges`, params)
    },

    // 응시여부 확인(check submited exam)
    // https://clpapi.tinkeredu.co.kr/static/docs/exam.html#resources-exam-independent-examinee-by-distribution
    dynamic(params) {
        return httpService.get(`/exam/independent/${params.distId}/exists/examinee`)
    },

    // 문항 이이제기(regist question issue)
    // https://clpapi.tinkeredu.co.kr/static/docs/exam.html#resources-exam-question-issue-register
    issue(params) {
        return httpService.post(`/exam/question/${params.questionId}/issue`,params)
    },

    // 단독 시험 목록(get independent Exam list)
    // https://clpapi.tinkeredu.co.kr/static/docs/exam.html#resources-exam-examinee-fetch-page
    independentExamineeExamList(params) {
        return httpService.get(`/exam/examinee`, params)
    },

    // 단독 시험응시자 상세(get independent exam examinee view)
    // https://clpapi.tinkeredu.co.kr/static/docs/exam.html#resources-exam-examinee-detail
    independentExamineeExamView(params) {
        return httpService.get(`/exam/examinee/${params.examineeId}`, params)
    },

    // 단독 시험 상세(get independent exam detail)
    // https://clpapi.tinkeredu.co.kr/static/docs/exam.html#resources-exam-independent-fetch-detail
    independentExamView(params) {
        return httpService.get(`/exam/independent/${params.distId}`, params)
    },

    // 게스트 단독시험 목록(get independent exam list for guest)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_independent_exam.html#resources-guest-exam-independent-fetch-page
    guestExamOnlineList(params) {
        return httpService.get(`/exam/independent`, params)
    },

    // 게스트 단독시험 갯수(get independent exam count for guest)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_independent_exam.html#resources-guest-exam-independent-fetch-count
    guestExamOnlineCount(params) {
        return httpService.get(`/exam/independent/count`, params)
    },

    // 게스트 단독시험 카테고리별 목록(get category independent exam list for guest)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_independent_exam.html#resources-guest-exam-independent-fetch-categorization
    guestExamOnlineCategoryList(params) {
        return httpService.get(`/exam/independent/categorization`, params)
    },
    
    
    // 게스트 단독시험 상세(get independent exam detail for guest)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_independent_exam.html#resources-guest-exam-independent-fetch-detail
    guestExamOnlineView(params) {
        return httpService.get(`/exam/independent/${params.distId}`, params)
        //return httpService.get(`/guest/${BRAND_CODE}/exam/independent/${params.distId}`, params)
    },

    // 게스트 단독시험 배지(get independent exam badges list for guest)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_independent_exam.html#resources-guest-exam-independent-badges
    guestExamOnlineViewBadges(params) {
        return httpService.get(`/exam/independent/${params.distId}/badges`, params)
        //return httpService.get(`/guest/${BRAND_CODE}/exam/independent/${params.distId}/badges`, params)
    },
// 단독 시험 카운트를 조회하는 API입니다.(my test count)
    // http://13.230.87.17:8080/static/docs/exam_examinee.html#resources-exam-examinee-count
    myEaxmCount(params) {
        return httpService.get(`/exam/examinee/count`, params)
    },

    // 시험 문항 이슈 목록 조회(Check list of test questions)
    // http://54.199.249.15:8080/static/docs/exam_question.html#resources-exam-question-issue-fetch-page
    eaxmIssueList(params) {
        return httpService.get(`/exam/question/issue`, params)
    },

    // 시험 문항 이슈 상세 조회(Detailed inquiry of test questions)
    // http://54.199.249.15:8080/static/docs/exam_question.html#resources-exam-question-issue-fetch-detail
    eaxmIssueDetail(params) {
        return httpService.get(`/exam/question/issue/${params.issueId}`)
    },

}

// export const 
export default examApi
